export default __webpack_public_path__ + "static/media/Return-Diagram-Light.ecf61e22.svg";